'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var script = {exports: {}};

exports.script = script;
